import { Warehouse, WarehouseResponse } from '../../models/warehouse.models';

export function mapWarehouseResponseToModel(
  response: WarehouseResponse,
): Warehouse {
  return {
    code: response.code,
    name: response.name,
    parentCode: response.parent_code,
    currencyCode: response.currency_code,
    gradingCode: response.grading_code,
    entityCode: response.entity_code,
    dccCode: response.dcc_code,
    wmsCode: response.wms_code,
    orderType: response.order_type,
    orderConsolidationDays: response.order_consolidation_days,
    activeFlag: response.active_flag,
    createdOn: new Date(response.created_on),
    updatedOn: new Date(response.updated_on),
    subInvCodeAuction: response.sub_inv_code_auction,
    subInvCodeOthers: response.sub_inv_code_others,
    orderTypeCodeAuction: response.order_type_code_auction,
    orderTypeCodeOthers: response.order_type_code_others,
    shippingFeeSku: response.shipping_fee_sku || '',
    allowedShippingMethods: response.allowed_shipping_methods,
    defaultShippingMethod: response.default_shipping_method,
    comments: response.comments || '',
  };
}
